import { RioApiGet } from "rio.react.all";
import { MergeFieldApiModel } from "../apiModels/MergeFieldApiModel";

export class MergeFieldApi {

    static getMergeFields() {
        return RioApiGet.asPromise<Array<MergeFieldApiModel>>("/api/MergeField/Get");
    }
}